module.exports = __webpack_public_path__ + "img/5@3x.34a4cb63.png";